"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : LINK : STYLES --------------- ++++++++++ */


var _default = {
  link: {
    cursor: 'pointer',
    transition: _index.theme.animation.general('all'),
    display: 'inline-flex',
    whiteSpace: 'nowrap',
    '& .inner': {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    // loader
    '& .loader': {
      display: 'none',
      fontSize: '38%',
      marginRight: (0, _index.pxToEm)(15),
      '& div': {
        borderTopColor: _index.theme.color.primary.medium.swatch
      }
    },
    '& a': {
      color: 'inherit',
      display: 'flex',
      alignItems: 'center'
    },
    // badge
    '& .badge': {
      marginLeft: (0, _index.pxToEm)(12)
    },
    // icon
    '&.icon-true': {
      '& .icon': {
        marginRight: (0, _index.pxToEm)(10)
      },
      '&.iconRight-true': {
        '& .text': {
          order: '-1'
        },
        '& .icon': {
          marginRight: '0',
          marginLeft: (0, _index.pxToEm)(10)
        }
      },
      '&.iconOnly-true': {
        '& .text': {
          display: 'none'
        },
        '& .icon': {
          marginRight: '0',
          marginLeft: '0'
        }
      }
    },
    '&.underline-true': {
      textDecoration: 'underline'
    },
    '&.underline-false': {
      textDecoration: 'none !important'
    },
    '&.isActive-true': {
      '&.allowmulticlick-false': {
        cursor: 'default',
        pointerEvents: 'none'
      }
    },
    '&.disabled-true': {
      extend: _index.disable
    },
    '&.processing-true': {
      cursor: 'default',
      pointerEvents: 'none',
      '& .loader': {
        display: 'inline-block'
      }
    },
    // ----- divider ----- //
    '& .divider': {
      color: 'inherit',
      display: 'inline-flex',
      height: '100%',
      width: (0, _index.pxToEm)(1),
      marginLeft: (0, _index.pxToEm)(10),
      marginRight: (0, _index.pxToEm)(10)
    },
    // ----- colors ----- //
    // generates classes for every color in the theme ".color-(uniqueColor)"
    extend: (0, _index.themeStyleHelper)(_index.theme, 'color', function (theme, uniqueColor) {
      return {
        color: theme.color[uniqueColor].medium.swatch,
        '& .loader div': {
          borderTopColor: theme.color[uniqueColor].medium.swatch
        }
      };
    }),
    // +++++ states +++++ //
    '&:hover': {
      filter: 'brightness(85%)'
    }
  }
};
exports.default = _default;